import Dashboard from './Dashboard';

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js